import {
  Box,
  Button,
  ButtonGroup,
  Center,
  Heading,
  Stack,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";

import { useNavigate } from "react-router";
import { MaterialIcon } from "../../../components/shared/MaterialIcon";

import ImageDark from "../../../assets/bg-dark.svg"; // relative path to image
import ImageLight from "../../../assets/bg-light.svg"; // relative path to image
import { Logo } from "../../../components/shared/Logo";

export interface SignInError {
  key?: string;
  status: string;
}

const StatsWelcome = () => {
  const navigate = useNavigate();
  const bgImageSrc = useColorModeValue(ImageLight, ImageDark);

  const handleOnNotify = () => {
    window.open("https://www.geneial.com/newsletter/", "_blank");
  };
  const handleOnView = () => {
    navigate("dashboard");
  };

  console.log("StatsWelcome");

  return (
    <Stack
      h="full"
      // backgroundImage={`url(${bgImageSrc})`}
      // backgroundSize="cover"
      // backgroundRepeat="no-repeat"
    >
      <Center h="full" position={"relative"}>
        <VStack spacing={24}>
          <Center h="full" position={"relative"}>
            <Box>
              <Logo.Base w={{ base: 32, md: 48, "2xl": 56 }} />
            </Box>
          </Center>
          <VStack spacing={12}>
            <VStack spacing={4}>
              <Heading color={"text.main"} as="h1" size="4xl">
                Public Dashboard
              </Heading>
              <Text color={"text.softer"} fontSize="xl">
                You are invited to view our aggregated anonymized awesome
                affable registry stats.
              </Text>
            </VStack>
          </VStack>
          <ButtonGroup size="lg" spacing={4}>
            <Button
              leftIcon={<MaterialIcon name="notifications" fontSize="1rem" />}
              onClick={handleOnNotify}
            >
              Join our newsletter
            </Button>

            <Button
              colorScheme={"accent"}
              rightIcon={
                <MaterialIcon name="arrow_right_alt" fontSize="1rem" />
              }
              onClick={handleOnView}
            >
              Open Stats
            </Button>
          </ButtonGroup>
        </VStack>
      </Center>
    </Stack>
  );
};

export default StatsWelcome;
